export default {
  brand: {
    name: 'USFansLink',
  },
  nav: {
    home: 'Accueil',
    guide: 'Guide USFans Spreadsheet',
    shoppingGuide: 'Guide d’achat',
    categories: 'Catégories',
    faq: 'FAQ',
    buyNow: 'Acheter maintenant',
    spread: 'USFans Spreadsheet',
  },
  lang: {
    label: 'Langue',
    en: 'English',
    pl: 'Polski',
    es: 'Español',
    fr: 'Français',
  },
  trust: {
    independent: 'Ressource indépendante',
    updated: 'Mis à jour régulièrement',
    multilingual: 'Multilingue',
  },
  footer: {
    tagline: 'Une ressource d’information indépendante pour les utilisateurs de la feuille de calcul USFans.',
    explore: 'Explorer',
    shop: 'Catégories de la boutique',
    mainSite: 'Visiter le site principal',
    guide: 'Lire le guide',
    disclaimer: 'USFansLink est une ressource d’information indépendante. Nous ne garantissons pas la disponibilité, l’authenticité, la qualité, le prix, la performance de livraison ni la sécurité d’aucun produit, vendeur ou service tiers. Vérifiez toujours les informations importantes de façon indépendante avant d’acheter.',
    rights: 'Tous droits réservés.',
  },
};